import { Motion, Presence } from 'solid-motionone'
import { css } from 'styled-system/css'
import { Grid } from 'styled-system/jsx'
import { darkmode } from './Header/DarkMode'

export const Splash = () => {
  return (
    <Presence>
      {/* 1. Main Viewport Container */}
      <Motion
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0, scale: 0.98 }}
        transition={{ duration: 0.4, easing: 'ease-out' }}
      >
        <Grid
          h="100vh"
          w="100vw"
          justifyContent="center"
          alignItems="center"
          bg='bg.default'
        >
          {/* 2. Entrance Scale Animation */}
          <Motion
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6, easing: [0.16, 1, 0.3, 1] }}
          >
            {/* Central Premium Container (Overflow Hidden is key here) */}
            <div
              class={css({
                position: 'relative',
                overflow: 'hidden', // Clips the shimmer so it doesn't spill outside the circle
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 'full',
                bg: 'jade.10',
                p: '1',
                boxShadow: darkmode()
                  ? '0 20px 40px rgba(0,0,0,0.5)'
                  : '0 20px 40px rgba(0,0,0,0.08)',
              })}
            >
              {/* 3. The Shimmer Layer */}
              <Motion
                animate={{ x: ['-150%', '200%'] }} // Sweeps from completely left to completely right
                transition={{
                  duration: 3,
                  repeat: Number.POSITIVE_INFINITY,
                  repeatDelay: 6, // Pauses for 2.5 seconds between each sweep so it isn't distracting
                  easing: 'ease-in-out',
                }}
                class={css({
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  zIndex: 10, // Places the shine OVER the logo and background
                  pointerEvents: 'none',
                  // The subtle faint color: adjusting opacity slightly based on dark mode for perfect contrast
                  background: darkmode()
                    ? 'linear-gradient(105deg, transparent 20%, rgba(255, 255, 255, 0.01) 50%, transparent 80%)'
                    : 'linear-gradient(105deg, transparent 20%, rgba(255, 255, 255, 0.1) 50%, transparent 80%)',
                })}
              />

              <img
                class={css({
                  height: '180px',
                  width: '180px',
                  display: 'block',
                  position: 'relative',
                })}
                src={`/${darkmode() ? 'logo' : 'logo_dark'}.png`}
                alt="sniper circle logo"
              />
            </div>
          </Motion>
        </Grid>
      </Motion>
    </Presence>
  )
}
